<template>
  <el-upload class="upload-demo" ref="importUp" name="file"
    :action="action"
    :with-credentials='true'
    :headers="headers" 
    :auto-upload="isAuto"
    :show-file-list="isShowFileList"
    :limit="limit"
    :on-success="handleSuccess"
    :data="params" 
    :on-preview="handlePreview" 
    :on-error="handleError" 
    :on-remove="handleRemove"
    :before-remove="beforeRemove" 
    :before-upload="beforeUpload"
    multiple 
    :on-exceed="handleExceed" 
    :file-list="fileList">
    <el-button type="primary">{{btnTitle}}</el-button>
    <div slot="tip" class="el-upload__tip">{{lineTip}}</div>
  </el-upload>
</template>
<script>
export default {
  props: ['action', 'params', 'btnTitle', 'uploadSectionFile', 'refresh'],

  data() {
    return {
      fileList: [],
      checkTip: '上传文件格式有误',
      isCheck: true,
      fileType: ['xls', 'xlsx'],
      fileSize: 2,
      limit: 5,
      lineTip: '',
      headers: {},
      isShowFileList: true,
      isAuto: true,
    };
  },
  watch: {},
  created() {
    this.headers = { token: this.$store.state.userInfo ? this.$store.state.userInfo.userToken : '' };
  },
  mounted() {},
  computed: {},
  methods: {
    beforeUpload(file) {
      if (this.isCheck) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        let arr = this.fileType;
        if (arr.indexOf(testmsg) === -1) {
          this.$message.warning(this.checkTip);
          return false; //return false就可以在格式大小不符后返回，不调用接口
        }
        const isLt2M = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt2M) {
          this.$message.warning(`上传文件大小不能超过${this.fileSize}MB`);
          return false;
        }
      }
    },
    handleSuccess(response, file, fileList) {
      // console.log(response, file, fileList);
      // this.$emit('setFileList',response)
      if (response.code == 0) {
        // this.$message.success(res.msg)
        this.$message.success('导入成功！');
        this.$emit('refresh');
        // this.handleQuery();
      } else if (response.code == 60001) {
        window.location.href = '/#/login';
      } else {
        this.$message.warning(response.msg);
        this.$refs.importUp.clearFiles();
      }
    },
    handleError(err, file, fileList) {
      this.$message.error('上传文件失败！');
      this.$refs.importUp.clearFiles();
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.$emit('delFile', fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择  ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      if (!this.isCheck) {
        //校验情况不需要弹窗
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-upload-list__item:focus {
  outline-width: 0;
  background: #f7e5e8;
}
/deep/.el-icon-close-tip {
  color: #de3242;
  background: #a0a0a0ab;
  padding: 2px;
}
</style>
